import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { PartnerService } from 'src/app/shared/services/partner.service';

@Component({
  selector: 'app-data-management-update-show-modal',
  templateUrl: './data-management-update-show-modal.component.html',
  styleUrls: ['./data-management-update-show-modal.component.scss']
})
export class DataManagementUpdateShowModalComponent implements OnInit {

  @Input() id: number;
  @Input() title: string;
  @Input() description: string;
  @Input() partnerGroup_id: number;

  @ViewChild('autosize') autosize: CdkTextareaAutosize;

  constructor(
    private dialogRef: MatDialogRef<DataManagementUpdateShowModalComponent>,
    private partnerService: PartnerService
    ) { }

  ngOnInit() {
  }

  close(): void {
    this.dialogRef.close();
    this.partnerService.notifyModalClosed(); // Notify modal closed  
  }

  updateProShow(title: string, description: string, id?: any, partnerGroup_id?: number) {
    this.partnerService.updateProShow(id, title, description, partnerGroup_id).subscribe((res: any) => {
      this.dialogRef.close();
    });
  }
}
